import { InputMode, InputType } from '../types/types';

export const inputTypeInputMode: Partial<Record<InputType, InputMode>> = {
  number: 'numeric',
  email: 'email',
};
